import { render, staticRenderFns } from "./AdminCityList.vue?vue&type=template&id=1063357a&scoped=true&"
import script from "./AdminCityList.vue?vue&type=script&lang=js&"
export * from "./AdminCityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063357a",
  null
  
)

export default component.exports